import { EU_LANGUAGES, normalizeEuLocale } from '../config/euLanguages';
import { VIEWER_STRINGS, type ViewerStringKey } from './viewerStrings.generated';

export type { ViewerStringKey };

export function viewerT(key: ViewerStringKey, locale?: string | null): string {
  const code = normalizeEuLocale(locale);
  return VIEWER_STRINGS[code]?.[key] ?? VIEWER_STRINGS.en[key] ?? key;
}

export function viewerLocaleOptions(availableCodes?: string[]) {
  const allowed = availableCodes?.length ? new Set(availableCodes) : null;
  return EU_LANGUAGES.filter((l) => !allowed || allowed.has(l.code));
}

export function detectViewerLocale(): string {
  return normalizeEuLocale(navigator.language);
}
